
export enum CreditCardProcessStatus {
    NotStarted,
    InProcesses,
    Finished
}

export interface CreditCardProcess {
    prossesingStatus: CreditCardProcessStatus,
    error: string,
    success: boolean
} 

export const CreditCardProcessIntialState: CreditCardProcess = {
    error: "",
    prossesingStatus: CreditCardProcessStatus.NotStarted,
    success: false    
};

export interface ChargeInvoicesModel {
    invoices: CreditCardARInvoice[],
    creditCardInfo: CreditCardModel,
    companyCode: string,
    entityType: string,
    entityCode: string
}

export interface CreditCardModel {
    id: string,
    number: string,
    cardType: string,
    last4: string,
    expiryMonth: string,
    expiryYear: string,
    cvv: string,
    avsZip: string,
    avsStreet: string,
    customer: CreditCardCustomerModel    
}

export interface CreditCardARInvoice  {
    paymentStatus: string,
    autCode: string,
    aRNum: string,
    toBeProcessed: boolean,
    address: string,
    email: string,
    result: string,
    amountToCharge: number,
    balance: number,
    invoiceAmount: number,
    aRName: string,
    sMName: string,
    invoiceNumber: string,
    companyCode: string,
    invoiceDate: string,
}

export const initialState: CreditCardModel = {
    id: '',
    number: '',
    cardType: '',
    last4: '',
    expiryMonth: '',
    expiryYear: '',
    cvv: '',
    avsZip: '',
    avsStreet: '',
    customer: { name: '', email: '' }
};

export const initialStateCargeModel: ChargeInvoicesModel = {
    invoices: [],  
    creditCardInfo: { ...initialState },    
    entityCode: '',
    entityType: '',
    companyCode: ''

}

export const initialStateCreditCardARInvoice: CreditCardARInvoice = {
    paymentStatus: '',
    autCode: '',
    aRNum: '',
    toBeProcessed:true,
    address: '',
    email: '',
    result: '',
    amountToCharge: 0,
    balance: 0,
    invoiceAmount: 0,
    aRName: '',
    sMName: '',
    invoiceNumber: '',
    companyCode: '',
    invoiceDate: ''
};



export interface CreditCardCustomerModel {
    name: string,
    email: string
}